export default function MessageSquareIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 16 16'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.3335 2.66683C3.15668 2.66683 2.98712 2.73707 2.86209 2.86209C2.73707 2.98712 2.66683 3.15668 2.66683 3.3335V12.3907L4.19543 10.8621C4.32045 10.7371 4.49002 10.6668 4.66683 10.6668H12.6668C12.8436 10.6668 13.0132 10.5966 13.1382 10.4716C13.2633 10.3465 13.3335 10.177 13.3335 10.0002V3.3335C13.3335 3.15669 13.2633 2.98712 13.1382 2.86209C13.0132 2.73707 12.8436 2.66683 12.6668 2.66683H3.3335ZM1.91928 1.91928C2.29436 1.54421 2.80306 1.3335 3.3335 1.3335H12.6668C13.1973 1.3335 13.706 1.54421 14.081 1.91928C14.4561 2.29436 14.6668 2.80306 14.6668 3.3335V10.0002C14.6668 10.5306 14.4561 11.0393 14.081 11.4144C13.706 11.7894 13.1973 12.0002 12.6668 12.0002H4.94297L2.47157 14.4716C2.2809 14.6622 1.99416 14.7193 1.74504 14.6161C1.49592 14.5129 1.3335 14.2698 1.3335 14.0002V3.3335C1.3335 2.80306 1.54421 2.29436 1.91928 1.91928Z'
        />
      </svg>
    </span>
  );
}
